import { io } from 'socket.io-client';

const API_BASE = process.env.REACT_APP_API_URL || 'https://backend-951385075735.europe-west1.run.app';

let socket = null;

/**
 * Returns a singleton Socket.IO connection to the discussions gateway
 * (default namespace), authenticated with the current session token.
 * Safe to call repeatedly — it reuses the existing connection.
 */
export function getSocket() {
    const token = localStorage.getItem('token');
    if (!token) return null;

    if (socket && socket.connected) return socket;

    if (!socket) {
        socket = io(API_BASE, {
            auth: { token },
            transports: ['websocket'],
            autoConnect: true,
        });
    } else {
        // Refresh auth token and reconnect if it was disconnected.
        socket.auth = { token };
        if (!socket.connected) socket.connect();
    }
    return socket;
}

let notificationSocket = null;

/**
 * Singleton Socket.IO connection to the `/notifications` namespace,
 * which pushes `notification:new` and `notification:unread-count` events.
 */
export function getNotificationSocket() {
    const token = localStorage.getItem('token');
    if (!token) return null;

    if (notificationSocket && notificationSocket.connected) return notificationSocket;

    if (!notificationSocket) {
        notificationSocket = io(`${API_BASE}/notifications`, {
            auth: { token },
            transports: ['websocket'],
            autoConnect: true,
        });
    } else {
        notificationSocket.auth = { token };
        if (!notificationSocket.connected) notificationSocket.connect();
    }
    return notificationSocket;
}

export function disconnectSocket() {
    if (socket) {
        socket.disconnect();
        socket = null;
    }
    if (notificationSocket) {
        notificationSocket.disconnect();
        notificationSocket = null;
    }
}
